/**
 * Switches between the cart and offers panels of the cart drawer (sections/cart-drawer.liquid).
 *
 * The tabs live in the drawer header and the panels in its body, which the theme's x-tabs cannot do: it keeps the tab
 * list inside its own shadow DOM next to the panels. Every cart change replaces the drawer content, so a fresh element
 * starts on the cart tab again, the same as x-tabs did.
 */

class CartDrawerTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  get tabs() {
    return Array.from(this.querySelectorAll('[role="tab"]'));
  }

  onClick = (event) => {
    const tab = event.target.closest('[role="tab"]');

    if (tab) {
      this.select(tab);
    }
  };

  onKeydown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    const tabs = this.tabs;
    const current = tabs.indexOf(document.activeElement);

    if (current === -1) {
      return;
    }

    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(current + step + tabs.length) % tabs.length];

    this.select(next);
    next.focus();
  };

  select(selectedTab) {
    const drawer = this.closest('cart-drawer');

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      const panel = drawer?.querySelector(`#${tab.getAttribute('aria-controls')}`);

      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;

      if (panel) {
        panel.hidden = !isSelected;
      }
    });
  }
}

if (!window.customElements.get('cart-drawer-tabs')) {
  window.customElements.define('cart-drawer-tabs', CartDrawerTabs);
}
